import { PRODUCT_TYPES } from "../modules/details/models/detail-page";
import { Bookmark } from "../modules/profile/models/bookmarks.model";
import { replaceUnderscore } from "./text-services";
interface ProductLink {
  id?: number;
  product_type?: number;
  name_english?: string;
  product_id?: number;
}
export const ROUTES = {
  root: "/",
  login: "/login",
  subscription: "/subscription",
  download: "/download",
  terms: "/terms",
  freeTraffic: "/free-traffic",
  contactUs: "/contact-us",
  aboutUs: "/about-us",
  editProfile: "/profile/edit-profile",
  subscriptions: "/profile/subscriptions",
  bookmarks: "/profile/bookmarks",
  visited: "/profile/visited",
  myBests: "/profile/my-bests",
  inviteFriends: "/profile/invite-friends",
  animations: "/animations",
  report: "/report",
  parental_control: "/parental-control",
  connection_error: "/connection-error",
  categories: "/category",
  collection: "/collection",
  discount_code: "/subscription/discount-code",
  blog: "/blog",
  blogSearch: "/blog/search",
  userPurchased: "/user_purchased",
  advertise: "/advertise",
  menu: "/menu",
  coldStart: "/cold-start",

  //Fun
  funDownloadPage: "https://www.digitoon.tv/fun/download/",

  //RADIOTOON
  radiotoon_detail: (productId: number) =>
    `https://www.digitoon.tv/radiotoon/album/${productId}`,

  //BAZITOON
  bazitoon_detail: (productId: number) =>
    `https://www.digitoon.tv/bazitoon/game/${productId}`,

  blogArticle: (id: number) => {
    return `/blog/${id}`;
  },
  blogHomeItem: (id: number) => {
    return `/blog/home-item/${id}`;
  },
  blogCategory: (id: number) => {
    return `/blog/category/${id}`;
  },

  blogSearchTag: (tag: string) => {
    return `/blog/search/?tag=${tag}`;
  },
  home: (categoryName: string, categoryId: number, showType?: number) => {
    return categoryId === (Number(process.env.NEXT_PUBLIC_ALL_CAT_ID) || 69)
      ? "/"
      : showType === 2
      ? `/${categoryName}/?list=true`
      : `/${categoryName}`;
  },
  category: (categoryName: string, categoryId: number) => {
    return `/category/${replaceUnderScore(
      categoryName,
      " ",
      "-"
    )}-${categoryId}`;
  },

  rootCategory: (categoryName: string) => {
    return `/${categoryName}`;
  },

  product: (product: ProductLink, fileId?: number) => {
    const selectedProductType =
      PRODUCT_TYPES.find(item => item.id === product.product_type) ||
      PRODUCT_TYPES[0];

    const productId = product?.product_id ? product.product_id : product.id;
    const productName =
      product?.product_type !==
      PRODUCT_TYPES.find(item => item.prod === "blog").id
        ? `${replaceUnderScore(product.name_english, " ", "-")}-`
        : "";
    const theresult = `/${selectedProductType.prod}/${productName}${productId}${
      fileId ? "/ep-" + fileId : ""
    }`;
    if (theresult.includes("Mighty-Express-Mighty-Trains-Race-59012")) {
      throw new Error("GOT IT &&&");
    }
    return theresult;
  },

  player: (
    product: ProductLink,
    episode: number,
    customVideo: boolean = false
  ) => {
    const selectedProductType = PRODUCT_TYPES.find(
      item => item.id === product.product_type
    );
    if (!selectedProductType) {
      console.error("product type unknown", product);
    }
    const productIdString =
      replaceUnderScore(product.name_english, " ", "-") + "-" + product.id;

    return (
      `/${selectedProductType.prod}/${productIdString}/ep-${episode}/player` +
      (customVideo ? "?customVideo=true" : "")
    );
  },
  discount: (code: string) => {
    return `/subscription/discount/?code=${code}`;
  },
  linkgPlayer: (productId: number) => {
    return `/linkg/${productId}`;
  },
  search: (categoryId: number, keyWord: string) => {
    return `/search/?catId=${categoryId}&keyword=${keyWord}`;
  },

  animationsItem: (item: {
    name_english: string;
    id: number;
    product_type?: number;
  }) => {
    const base = item.product_type === 4 ? "/game" : ROUTES.animations;
    return (
      base +
      "/" +
      replaceUnderscore(item.name_english + "-" + item.id, " ", "-")
    );
  }
};

const replaceUnderScore = (
  value: string,
  regexValue: string,
  replaceValue: string
) => {
  if (!value) return "";
  let regx = new RegExp(regexValue, "g");
  return value
    .replace(regx, replaceValue)
    .replace("---", "-")
    .replace(
      /\||\/|{|}|\|\^|\?|\*|[|]|\+|`|;|:|@|=|\$|,|\.|<|>|"|#|&|%|~|!|\(|\)|"|\\|`|;|'/g,
      ""
    )
    .replace("--", "-");
};
